import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { VersionCheckerService } from '../services/version-checker.service';

import packageInfo from 'package.json';

@Injectable()
export class VersionCheckerInterceptor implements HttpInterceptor {
	protected requiredHeaders: Record<string, string> = {};

	constructor(private versionCheckerService: VersionCheckerService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const req = request.clone({
			setHeaders: {
				'X-APPLICATION-VERSION': packageInfo.config.ref,
				...this.requiredHeaders,
			},
		});

		return next.handle(req).pipe(
			tap((res) => {
				if (res instanceof HttpResponse) {
					const versionMismatch = res.headers.get('VERSION_MISMATCH');
					this.versionCheckerService.handleVersionMismatch(versionMismatch);
				}
			})
		);
	}
}
